import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pr-2"
}
const _hoisted_2 = { class: "flex-fill" }
const _hoisted_3 = { key: 2 }

import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {computed} from "vue";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "SideMenuCard"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    collapsed: { type: Boolean },
    margin: { type: Boolean, default: true },
    withoutPadding: { type: Boolean },
    cardClass: {}
  },
  emits: ["update:collapsed"],
  setup(__props: any, { emit: __emit }) {

let props = __props;


let emits = __emit;

let collapsable = computed(() => typeof props.collapsed == 'boolean');

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.$slots.title)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass({
                'd-flex title w-100 sticky': true,
                'cursor-pointer': _unref(collapsable),
                'collapsed': __props.collapsed,
            }),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('update:collapsed', !_unref(props).collapsed)))
        }, [
          (_unref(collapsable))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(FontAwesomeIcon, {
                  icon: __props.collapsed ? 'chevron-right' : 'chevron-down'
                }, null, 8, ["icon"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "title")
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.$slots.default)
      ? _withDirectives((_openBlock(), _createBlock(_component_el_card, {
          key: 1,
          class: _normalizeClass({
                'side-menu-card': true,
                 margin: __props.margin,
                 'p-0': __props.withoutPadding,
                 [_unref(props).cardClass]: true
            })
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["class"])), [
          [_vShow, !__props.collapsed || !_unref(collapsable)]
        ])
      : _createCommentVNode("", true),
    (_ctx.$slots.append)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "append")
        ], 512)), [
          [_vShow, !__props.collapsed || !_unref(collapsable)]
        ])
      : _createCommentVNode("", true)
  ]))
}
}

})